module.exports = __webpack_public_path__ + "img/WALMART.85452730.png";